import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import ConfirmDialog from './ConfirmDialog';

// Single log-out control, reused by the account hub, the header menu, and the
// admin shell so the confirm-then-sign-out flow lives in one place. Opens the
// app's ConfirmDialog (never a browser confirm()), then calls
// AuthContext.signOut and returns the visitor to the home page. Styling is
// passed in per location via className/style; label + icon are configurable.
export default function LogoutButton({
  className,
  style,
  label = 'Log out',
  showIcon = true,
  iconSize = 16,
  onBeforeLogout,
  'aria-label': ariaLabel,
}) {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    setConfirming(false);
    if (onBeforeLogout) onBeforeLogout();
    await signOut();
    navigate('/', { replace: true });
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setConfirming(true)}
        className={className}
        style={style}
        aria-label={ariaLabel || label || 'Log out'}
      >
        {showIcon && <LogOut size={iconSize} />}
        {label}
      </button>
      {confirming && (
        <ConfirmDialog
          title="Log out?"
          message="You'll need to sign back in to access your account."
          confirmLabel="Log out"
          cancelLabel="Cancel"
          danger={false}
          onConfirm={handleConfirm}
          onCancel={() => setConfirming(false)}
        />
      )}
    </>
  );
}
